import Vue from 'vue';
import router from './router';
import VueHighlightJS from 'vue-highlightjs';
import VueDisqus from 'vue-disqus';
import "highlight.js/styles/github.css"; // highlight.js 테마 설정
import App from './components/App.vue';
Window.Vue = Vue;
Vue.config.productionTip = false;
Vue.use(VueHighlightJS);
Vue.use(VueDisqus);

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
